import * as types from '../types.js'

export const initialState = {
  title: 'Login | Northwestern Mutual',
  nmUniqueId: 'no_user',
  finalRedirectUrl: null,
  supportHours: {},
  clearSession: false,
  logoutUrls: {
    urls: {},
    nmisLogoutUrl: {}
  },
  mobileWebViewState: {
    shouldShowAndroidBanner: false
  }
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SET_NMUNIQUEID: {
      return { ...state, nmUniqueId: payload }
    }

    default: {
      return state
    }
  }
}
